import { CDBTable, CDBTableHeader, CDBTableBody } from "cdbreact";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import ConcluirVendaModal from "../modal/ConcluirVendaModal";
import Select from "react-select";
import { useEffect, useState } from "react";
import { listAllSalesByStatus } from "../../../../services/SaleService";
const dayjs = require("dayjs");

const VendasAbertasTable = (props) => {
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [sales, setSales] = useState();
  const [pageInfo, setPageInfo] = useState();

  useEffect(() => {
    if (props.sales) {
      setSales([...props.sales]);
    }
  }, [props.sales]);

  function handleChangeCustomer(customer) {
    if (customer) {
      setSelectedCustomer(customer);
      listSales(customer.value);
    } else {
      setSelectedCustomer();
      setSales([...props.sales]);
      setPageInfo(props.pageInfo);
    }
  }

  function listSales(customerId) {
    listAllSalesByStatus("OPENED", customerId)
      .then((response) => {
        setSales(response.data);
        setPageInfo(response.pageInfo);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  return (
    <>
      <>
        <div className="d-lg-flex mb-3" style={{ minWidth: "18rem" }}>
          <Select
            id="customerSelect"
            name="customers"
            classNamePrefix="select"
            options={props.customers}
            className="basic-multi-select"
            value={selectedCustomer}
            onChange={(customer) => handleChangeCustomer(customer)}
            isClearable
            formatOptionLabel={formatCustomersLabels}
            placeholder="Filtrar vendas a abertas de um cliente"
          />
        </div>

        <CDBTable className="alcon-table" responsiveSm borderless>
          <thead>
            <tr>
              <th>Data / Hora</th>
              <th>Veículo / Placa</th>
              <th>Cliente</th>
              <th>Total</th>
              <th className="text-end px-4">Ações</th>
            </tr>
          </thead>
          <tbody>
            {sales && sales.map((sale) => (
              <tr key={sale.id}>
                {/* Data formatada com hora menor */}
                <td className="text-muted small align-middle">
                  <div className="fw-bold">{dayjs(sale.createdAt).format("DD/MM/YYYY")}</div>
                  <div className="opacity-75">{dayjs(sale.createdAt).format("HH:mm")}</div>
                </td>

                {/* Informação do Veículo com destaque */}
                <td className="align-middle fw-bold text-dark">
                  <i className="fas fa-car me-2 text-secondary small"></i>
                  {sale.vehicleInfo}
                </td>

                {/* Cliente com ícone ou fallback */}
                <td className="align-middle text-muted">
                  <i className="fas fa-user-circle me-1 small"></i>
                  {sale.customer ? sale.customer.name : "Não identificado"}
                </td>

                {/* Valor Total em destaque de sucesso */}
                <td className="align-middle">
                  <span className="fw-bold text-success" style={{ fontSize: '1.05rem' }}>
                    {currencyBRFormat(sale.total)}
                  </span>
                </td>

                {/* Ações: Botão de Concluir (Modal) */}
                <td className="text-end align-middle px-3">
                  {/* O seu Modal já deve renderizar o botão, mas garanta que ele siga o estilo */}
                  <ConcluirVendaModal
                    sale={sale}
                    listSales={props.listSales}
                    customers={props.customers}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </CDBTable>
      </>
      <div>
        {sales && sales.length === 0 ? (
          <>
            Nenhuma venda a aberta
            {selectedCustomer ? " de " + selectedCustomer.label : ""}
          </>
        ) : (
          <div className="d-flex justify-content-end">
            <label>Total a Receber</label>
            <div className="mx-2 ">
              {currencyBRFormat(
                sales && sales
                  .map((sale) => sale.total)
                  .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default VendasAbertasTable;

const formatCustomersLabels = (customer) => (
  <>
    <span>{customer.label}</span>
    <span> - {customer.key}</span>
  </>
);
